import { StatusBadge } from './StatusBadge';
import type { OperationalStatus } from '../../design-system/status';

interface BatteryHealthProps {
  label: string;
  value: number;
  status: OperationalStatus;
  detail?: string;
}

const barTone: Record<string, string> = {
  GOOD: 'bg-console-good',
  APPROVED: 'bg-console-good',
  HALF: 'bg-console-half',
  RETEST: 'bg-console-half',
  RECHARGE: 'bg-console-half',
  RECARGA: 'bg-console-blueSoft',
  DEFECT: 'bg-console-defect',
  FAILED: 'bg-console-defect',
};

export function BatteryHealth({ label, value, status, detail }: BatteryHealthProps) {
  const width = Math.max(4, Math.min(100, value));

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between gap-4">
        <div>
          <p className="console-label">{label}</p>
          {detail && <p className="mt-1 font-mono text-xs text-console-muted">{detail}</p>}
        </div>
        <div className="flex items-center gap-3">
          <span className="console-value text-lg">{value.toFixed(1)}%</span>
          <StatusBadge status={status} />
        </div>
      </div>
      <div className="h-2 overflow-hidden rounded-full bg-console-line">
        <div className={`h-full rounded-full ${barTone[status] ?? 'bg-console-muted'}`} style={{ width: `${width}%` }} />
      </div>
    </div>
  );
}
